export const adaptHashtag = (data: IAdminHashtag): AdminHashtag => {
	return {
		uuid: data.uuid,
		name: data.name,
		color: data.color,
		description: data.description,
		image: data.image,
		isPrivate: data.is_private,
		isFavourite: data.is_favourite,
		favouriteOrdering: data.favourite_ordering,
		excludeFromMainFeed: data.exclude_from_main_feed,
		deleted: data.deleted,
		source: data.source,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptHashtags = (data: IAdminHashtag[]): AdminHashtag[] => {
	return data.map(adaptHashtag);
};
